<template lang="pug">
  v-container#top(fluid)
    v-layout.jumbotron(column align-center)
      v-flex.album.text-xs-center
        v-card
          v-layout.elevation-5.grey.darken-4(row)
            v-flex.album-card
              v-card-title
                p.caption(style="margin:0") {{ album.id }}
                p.display-1 {{ album.title }}
                p.headlines {{ album.subtitle }}
              v-card-media
                img.album-img(:src="require('../assets/images/albums/' + album.img_url)" width="300")
              v-card-actions
                p.headlines.grey--text Theme: {{ album.theme }}
                p.headlines Release: {{ album.release_date }}
                div(v-for="p in album.lead_text" :key="p")
                  p.headlines {{ p }}
                v-list.grey.darken-4
                  v-list-group(no-action)
                    v-expansion-panel
                      v-expansion-panel-content
                        div(slot="header")
                          v-card(v-for="(track, index) in album.tracks" :key="index")
                            v-card-content.track-card
                              v-list.grey.darken-4(dense style="margin-bottom: 2em;")
                                p.caption(style="margin-bottom:0.5em;") {{ track.id }}
                                p.body-1 {{ track.track }}
                                p.grey--text {{ track.author }}
                                //p(v-if="track.genre.length!=0") {{ track.genre }}
                                //p(v-if="track.poem") {{ track.poem }}
                                hr.grey.darken-3
                    v-divider.mx-3
                    p.headlines(v-if="album.artwork_design") ArtWork Designer: {{ album.artwork_design }}
                    p.headlines(v-if="album.mastering") Mastaring: {{ album.mastering }}
              v-btn.grey.darken-3(href="/release" icon)
                i.fas.fa-caret-left
              v-btn.hrefbutton.primary(href="") download
              v-btn.blue(icon target="_blank" :href="twitter_head + album.title + '%0a' + album.lead_text.join(' ') + twitter_bottom + '/' + album.id")
                i.fab.fa-twitter

</template>

<script>
let db = require('@/assets/db.json');
export default {
  data () {
    return {
      twitter_head: "https://twitter.com/intent/tweet?text=",
      twitter_bottom: "&hashtags=ツルレコ&url=" + encodeURIComponent(location.href),
      album: db.releases.filter(element => element.id === this.$route.params.id.toUpperCase())[0]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
i {
  margin-left: 0.5em;
  margin-right: 0.5em;
}
@mixin display-size-page {
  min-height: 100vh;
  min-width: 100vw;
  padding-right: 10%;
  padding-left: 10%;
}
#top {
  padding: 0;
}
.jumbotron {
  @include display-size-page;
  background-size: cover;
  background-position: center;
  background-image: url("../assets/images/top.jpg");
}
.hrefbutton {
  width: 150px;
}
.album {
  margin: 10vh 10px 10vh 10px;
}
.album-card {
  padding: 30px 10px 30px 10px;
}
.album-img {
  width: 100%;
  max-width: 30vh;
  padding-bottom: 10px;
}
.track-card {
  p {
    margin:0;
  }
}
</style>
